<template>
  <div style="width: 100%;" class="custom-container">
    <v-row dense no-gutters>
      <v-col cols="12">
        <Table
          :key="tableKey"
          :items="templates"
          :loading="loading"
          @activeOnly="activeOnlyFunction($event)"
          @fetchTemplates="fetchTemplates($event)"
          @copyCreate="copyCreate($event)"
        ></Table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Table from './TemplatesDatatable'
import { getTextTemplatesUsingGET as getTemplates } from '@/utils/api'
import { mapActions } from 'vuex'
import { copyCreateTemplate } from '@/utils/helpers'

export default {
  components: {
    Table
  },
  data() {
    return {
      err: '',
      success: '',
      activeOnly: true,
      tableKey: 0,
      loading: false,
      templates: { items: [], meta: {} }
    }
  },
  computed: {},
  created() {
    if (this.$route.params && this.$route.params.message) {
      this.addSnackbar({
        message: this.$route.params.message,
        timeout: 5000,
        color: 'success'
      })
    }
  },
  methods: {
    ...mapActions('app', ['addSnackbar']),
    copyCreate(item) {
      copyCreateTemplate(item)
        .catch((err) => {
          this.addSnackbar({
            message: err,
            timeout: 5000,
            color: 'error'
          })
        })
    },
    activeOnlyFunction(event) {
      this.activeOnly = event.activeOnly

      this.fetchTemplates(event.options)
    },
    fetchTemplates(options) {
      this.loading = true

      const obj = {}

      if (options) {
        if (options.options && options.options.itemsPerPage !== -1) {
          obj.page = options.resetPage ? 1 : options.options.page || 1
          obj.size = options.options.itemsPerPage || 25
        } else {
          obj.page = 1
          obj.size = 25
        }
      } else {
        obj.page = 1
        obj.size = 25
      }

      if (options?.options?.sortDesc && options.options.sortDesc.length > 0) obj.orderDirection = options.options.sortDesc[0] ? 'DESC' : 'ASC'

      if (options && options.options && options.options.sortBy && options.options.sortBy.length > 0) {
        obj.orderField = options.options.sortBy[0]
      }

      if (options && options.search && options.search.length > 1) {
        obj.name = options.search
      }

      if (this.activeOnly) obj.status = 'ACTIVE'

      getTemplates(obj)
        .then((res) => {
          this.templates = res.data.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.addSnackbar({
            message: error,
            timeout: 5000,
            color: 'error'
          })
          console.log(error)
        })
    }
  }
}
</script>
